
import { Component, Vue } from 'vue-property-decorator';
import {
  PerformoSettings,
  UsersApi,
  User,
  Property,
  PropertiesApi
} from 'performo-api';
import BuildingDisplayComponent from '@/components/system/BuildingDisplayComponent.vue';
import { mapGetters } from 'vuex';

@Component({
  components: {
    BuildingDisplayComponent
  },
  computed: mapGetters({
    settings: 'settings',
    currentProperty: 'currentProperty',
    propertyApi: 'propertiesApi'
  })
})
export default class MyProfile extends Vue {
  // user profile vuemodel
  private api = new UsersApi(this.$store.getters.getApiConfiguration);
  private propertyApi!: PropertiesApi;
  private settings!: PerformoSettings;
  private currentProperty!: Property;
  private contactProperty?: Property | null = null;
  private user: User = { contact: {} };

  get currentUserName(): string {
    return this.user &&
      this.user.contact &&
      this.user.contact.firstName &&
      this.user.contact.lastName
      ? this.user.contact.firstName + ' ' + this.user.contact.lastName
      : this.$store.getters.userDisplayName;
  }
  get floorLabel(): string {
    return this.currentProperty.floorLabel
      ? this.currentProperty.floorLabel
      : 'Floor';
  }

  private async getUser() {
    this.user = await this.api.getMyProfile();
    this.contactProperty =
      this.user.contact && this.user.contact.propertyId
        ? await this.propertyApi.getProperty({
            propertyId: this.user.contact?.propertyId
          })
        : null;
  }

  private async mounted() {
    this.getUser();
  }
}
